import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { parse, format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';

function RankingItem({ row, index, onSelect, isSelected }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const ranking = row.original;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCheckboxChange = () => onSelect(ranking.id);

    const { key, ...rowProps } = row.getRowProps();

    return (
        <tr {...rowProps} className="bmember-b bmember-stroke border-b border-gray-200">
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium uppercase text-sm">{ranking.nome}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{ranking.cpf}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{ranking.rg}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{ranking.fone}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{ranking.razao}<br/>({ranking.cnpj})</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">
                {ranking.posicao == 1 && (
                    <span className="focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-yellow-900">
                     <FontAwesomeIcon icon={faTrophy} className="text-white pr-[5px] mb-[1px]" />
                        {
                            ranking.pontos
                        }
                    </span>
                )}
                {ranking.posicao == 2 && (
                    <span className="focus:outline-none text-white bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-gray-900">
                        {
                            ranking.pontos
                        }
                    </span>
                )}

                {ranking.posicao == 3 && (
                    <span className="focus:outline-none text-white bg-yellow-700 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-Yellow-900">
                        {
                            ranking.pontos
                        }
                    </span>
                )}

                {ranking.posicao == null && (
                    <span className="focus:outline-none text-dark bg-transparent hover:bg-transparent focus:ring-4 focus:ring-transparent font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-Yellow-900">
                        {
                            ranking.pontos
                        }
                    </span>
                )}
            </td>
        </tr>
    );
}

export default RankingItem;
